<h2 mat-dialog-title>{{ 'Leave_the_tour_tr' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'you_can_exit_tour_anytime_tr' | translate }}</p>
  <div class="tour-exit-option" (click)="dontShow = !dontShow">
    <mat-checkbox [checked]="dontShow" (click)="dontShow = !dontShow; $event.stopPropagation()"></mat-checkbox>
    <span>{{ 'donot_show_again_tr' | translate }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button [mat-dialog-close]="undefined">
    {{ 'Continue2_tr' | translate }}
  </button>
  <button type="button" mat-raised-button color="primary" [mat-dialog-close]="dontShow">
    {{ 'exit_tour_tr' | translate }}
  </button>
</mat-dialog-actions>
